import { render } from "./Charge.vue?vue&type=template&id=6da8d54a&scoped=true"
import script from "./Charge.vue?vue&type=script&lang=js"
export * from "./Charge.vue?vue&type=script&lang=js"

import "./Charge.vue?vue&type=style&index=0&id=6da8d54a&lang=scss&scoped=true"

import exportComponent from "D:\\ideaWorkSpace\\政泉\\zhengquan\\sqlpj-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da8d54a"]])

export default __exports__